export const processHistoricSensorRow = (kpodData, index, processedKpodData) => {
  const [kpodId, data] = kpodData;
  const next = processedKpodData[index - 1];
  
  return {
    kpodId: kpodId || 'N/A',
    installation: data?.installation,
    installationEnd: next ? next[1]?.installation : null,
    totalUsages: data?.total_usages,
    isCurrent: !next
  };
};

export const formatHistoricSensorRow = (rowData, formatDate) => {
  return {
    ...rowData,
    installationFormatted: rowData.installation ? formatDate(rowData.installation) : '-',
    installationEndFormatted: rowData.installationEnd ? formatDate(rowData.installationEnd) : "Current",
    totalUsagesFormatted: rowData.installationEnd && rowData.totalUsages 
      ? rowData.totalUsages.toLocaleString() 
      : "-"
  };
};